<template>
  <!--询盘服务-->
  <div class="ab-intelligent-search">
    <!-- <Layout> -->
    <div class="ab-intelligent-search-header">
      <div class="ab-banner-header">
        <MainNav />
        <div class="clearfix"></div>
        <div class="ab-intelligent-search-info">
          <div class="warp">
            <div class="banner-title fontsize50" data-aos="fade-down">
              全球企业信息查询平台
            </div>
            <div
              class="banner-sub-title fontsize20"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              查外企<em></em>找客户
            </div>
            <div class="banner-tabs" data-aos="fade-down" data-aos-delay="200">
              <a-tabs type="card" v-model="activeKey" @change="tabChange">
                <a-tab-pane key="ENTERPRISE" tab="公司名">
                  <a-input-group>
                    <a-input-search
                      placeholder="请输入公司名称"
                      ref="ENTERPRISE"
                      class="inputSearch"
                      @search="onSearch"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <ul class="ab-intelligent-search-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('shower faucet')"
                      >
                        shower faucet
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('wallpaper')"
                      >
                        wallpaper
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="onSearch('crane')">
                        crane
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('prepainted steel')"
                      >
                        prepainted steel
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('auto radiator')"
                      >
                        auto radiator
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('graphite electrode')"
                      >
                        graphite electrode
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                </a-tab-pane>
                <a-tab-pane key="PRODUCT" tab="产品名">
                  <a-input-group>
                    <a-input-search
                      placeholder="请输入产品名称"
                      class="inputSearch"
                      ref="PRODUCT"
                      @search="onSearch"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <ul class="ab-intelligent-search-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Fiber optic terminal box')"
                      >
                        Fiber optic terminal box
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('supermarket shelf')"
                      >
                        supermarket shelf
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Silicone product')"
                      >
                        Silicone product
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('wood chipper')"
                      >
                        wood chipper
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('recreation product')"
                      >
                        recreation product
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                </a-tab-pane>
                <!-- <a-tab-pane key="3" tab="国家地区">
                  <a-input-group>
                    <a-input-search
                      placeholder="请输入国家/地区"
                      class="inputSearch"
                      @search="onSearch"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <ul class="ab-intelligent-search-a clearfix">
                    <li>
                      <a href="javascript:void(0)"
                      @click="onSearch('')">
                        Schlumberger Australia Pty Ltd
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                      @click="onSearch('')">
                        Logistique Et Transit Polynesie
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                      @click="onSearch('')">
                        Royal Caribbean Cruises Ltd
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                </a-tab-pane> -->
              </a-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Content> -->
    <!--智能拓客平台-->
    <CustomerPlatform v-bind="platformData"></CustomerPlatform>
    <div class="clearfix"></div>
    <!-- <div class="clearfix"> -->
    <Competitive :dataList="competitiveData"></Competitive>
    <!-- </div> -->

    <!--服务列表价格清单-->
    <!-- <ServerList></ServerList> -->
    <!--问题列表-->
    <QuestionList v-bind="questionData"></QuestionList>
    <!--已服务列表-->
    <CustomerList></CustomerList>
    <!-- </Content> -->
    <!-- <Footer> -->
    <FooterBanner
      ><img src="~@/assets/product/fb_1.png" alt="数据外贸营销，从现在开始！"
    /></FooterBanner>
    <!-- </Footer> -->
    <!-- </Layout> -->
    <list-modal-vue
      :visible="visible"
      :keywords="keywords"
      :type="activeKey"
      @cancel="handleCancel"
    ></list-modal-vue>

    <!-- 搜索提示 -->
    <!-- <a-modal    width="760px" v-model="visible" title="搜索提示" :footer="null" class="ad-tips">
      <p>  <img src="~@/assets/product/image_搜索上限.png" alt=""> </p>
      <p>今日检索已到上限，注册账号获得更多检索机会</p>
      <a href="https://crm.cnabke.com/#/passport/register"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register"   target="_blank">
          <a-button type="primary">
               立即注册
          </a-button>
      </a>
    </a-modal> -->
  </div>
</template>

<script>
import MainNav from '@/components/MainNav.vue';
import Competitive from '@/components/Competitive.vue';

import QuestionList from '@/components/QuestionList.vue';
import CustomerList from '@/components/CustomerList.vue';
import FooterBanner from '@/components/FooterBanner.vue';

import CustomerPlatform from '@/components/CustomerPlatform.vue';
import ListModalVue from './IntelligentSearch/ListModal.vue';
import metaInfo from '@/metaInfo';
export default {
  metaInfo: metaInfo['intelligent-search'],
  components: {
    MainNav,
    Competitive,
    QuestionList,
    CustomerList,
    FooterBanner,
    CustomerPlatform,
    ListModalVue,
  },
  data() {
    return {
      visible: false,
      keywords: '',
      activeKey: 'ENTERPRISE',
      questionData: {
        blockTitle: '常见问题',
        blockSubTitle: '帮助客户快速解决问题',
        listData: [
          {
            q: '客户智搜可以检索到企业的哪些信息？',
            a:
              '通过输入需检索的公司名称、产品关键词、国家地区可以快速检索到相关企业信息，包含：企业名称、所在国家/城市、经营状态、注册日期、产品服务介绍、公司简介、电话、传真等联系方式及管理层人员相关信息，配合AB客其他产品可以查询企业相关贸易信息。',
          },
          {
            q: '客户智搜能给外贸人带来什么价值？',
            a:
              '客户智搜可以帮助外贸人全面的了解企业客户背景及经营存续状态，从根本上降低企业交易风险，同时可以通过组织架构快速定位相关决策人，有效缩短外贸人调研、了解、洽谈合作的时间，帮助外贸人快速建立商机。',
          },
          {
            q: '客户智搜是如何收取费用的？',
            a:
              '客户智搜分为不同的应用版本，不同的版本所包含的积分数量不同，根据需解锁内容的不同而收取相应的积分，用户可以根据自己的实际需求进行查询检索，直至所有积分消耗完为止。',
          },
          {
            q: '检索后的客户如何跟进联系？',
            a:
              '解锁后的客户支持添加已有客户和新创建客户，可直接分配给跟进人员，一旦分配跟进人员，则同一个账号主体下的其他业务员不能添加该客户，防止撞单。客户智搜添加的客户可在CRM中的客户管理中查看并实时添加跟进记录。',
          },
        ],
      },
      competitiveData: {
        title: '区别于市面其他产品',
        subTitle: '更全面精准的商情分析',
        data: [
          {
            title: '市面其他产品',
            features: [
              '相关公司信息不完善且可信度较低',
              '无法获知企业是否正常经营存续',
              '企业背景一般不含组织机构信息',
              '一套应用无法监测相关客户的动态',
              '与实际应用需求不匹配且资费高',
            ],
          },
          {
            title: 'AB客客户智搜',
            features: [
              '数据源可靠且真实，买家相关信息完整',
              '多渠道数据实时对比优化更新企业数据',
              '智能分解组织结构，精准锁定决策管理',
              '全面打通旗下产品触点，快速联动触达',
              '不同版本可满足不同类型企业客户需求',
            ],
          },
        ],
      },
      platformData: {
        blockTitle: '智能商业分析平台',
        blockSubTitle: '数据更全面，获客更高效',
        blockList: [
          {
            title: '买家背景调查分析',
            content:
              '全球200+国家及地区，数十亿海外企业背景透视报告，涵盖其企业概况、经营存续状态、联系地址、企业关系、组织架构、周边关联等风险披露信息，信息自动补全，来源可靠且持续更新。',
            image: 'product/买家背景调查分析.jpg',
          },
          {
            title: '智能风控分析',
            content:
              '多维度风险指标监控与分析，实时监测企业客户存续、运营风险，统一监控管理、合规筛查、智能监测企业客户风险变化，全面提升交易风险防范能力，降低企业隐性运营风险。',
            image: 'product/智能风控分析.jpg',
          },
          {
            title: '贸易情报分析',
            content:
              '基于AI人工智能、知识图谱技术和独有的企业数据核心算法，追踪采购商贸易行为，分析其上下游供应链构成和变化规律，及时掌握潜在买家行为动态，挖掘更多营销机会。',
            image: 'product/贸易情报分析.jpg',
          },
          {
            title: '决策链分析',
            content:
              '依托强大的数据分析计算能力，快速检索企业不同角色管理层，构建客户角色模型，纵向模拟采购交易流程，快速锁定项目决策链关键人物，帮助企业科学制定全球营销策略。',
            image: 'product/决策链分析.jpg',
          },
        ],
      },
    };
  },
  methods: {
    onSearch(value) {
      value = value.trim();
      if (!value) {
        return;
      }
      this.visible = true;
      this.keywords = value;
      this.$refs[`${this.activeKey}`].focus();
    },

    handleCancel() {
      this.visible = false;
    },

    tabChange(key) {
      this.activeKey = key;
    },
  },
};
</script>

<style lang="sass" scoped>
  
  .ad-tips{
    ::v-deep .ant-modal-close-x{
      i{
        &:hover{
            opacity: 1;
        }
    background: #fff;
    border-radius: 50%;
    opacity: .7;
    padding: 8px;
        margin-top: 23px;
    margin-right: 24px;
      }
    }
   ::v-deep  .ant-modal-content{
    border-radius:20px;
    overflow: hidden;
    }
    button{
      width: 200px;
      height:64px;
      font-size:20px;
      margin: 20px 0px 40px 0px;
    }
    ::v-deep .ant-modal-body{
      text-align:center;
      font-size: 20px;

    }
   ::v-deep .ant-modal{

  }
  ::v-deep .ant-modal-header{
    height: 80px;
background: #2B68FF;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    .ant-modal-title{
    color:#fff;
    font-size: 24px;
        margin: 0px auto;
    }
  }
}
::v-deep .ab-question .q-list .q-item .q-block{
  height: auto;    min-height:7rem;padding-bottom:10px;
}
::v-deep .ab-intelligent-search-header .ant-affix{
  .nav-logo{
    display: inline-block;
  }
   .nav-logo-white{
  display: none;
 }
}
::v-deep .ab-intelligent-search-header {
  .nav-logo{
    display: none;

  }
 .nav-logo-white{
  display: inline-block;
 }
}
.ab-intelligent-search{

  .ab-intelligent-search-header {
    height:510px;
    background: url('~@/assets/product/banner_客户智搜.jpg') no-repeat;
    background-size: cover;
  }

  .banner-tabs{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ab-banner-header {
    width: 100%;
  }

  .ab-intelligent-search-info{
    padding-top: 40px;
    .banner-title{
      font-family: AlibabaPuHuiTiM;
      color: #FFFFFF;
      line-height: 69px;
      text-align: center;
    }

    .banner-sub-title{
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(255,255,255,.8);
      text-align: center;
      padding-top:6px;
      line-height: 27px;
      padding-bottom:20px;
      em{
        display: inline-block;
        width:10px;
      }
    }

    .inputSearch{
      width: 1090px;
      margin-top:4px;
      margin-bottom:3px;
      ::v-deep .ant-input-group-addon{
        background-color: transparent;
      }
      ::v-deep .ant-btn{
        i{
          font-size:33px;
          position: absolute;
          top: 7px;
          left: 23px;
        }
         height:64px;
         background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
         text-indent: 21px;
         border:none;
         width: 160px;
        font-size: 20px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        &:hover{
           background: linear-gradient(230deg, #217AF9 0%, #0964e5 100%);
        }
      }
      ::v-deep .ant-input{
        height:64px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        font-size: 20px;
        text-indent: 29px;
        font-family: 'Alibaba-PuHuiTi-R';

      }
    }

    .ab-intelligent-search-a li:last-child a em{
      display: none;
    }

    .ab-intelligent-search-a{
      padding-left:18px;
      li{

        a{
          &:hover{
              color:#fff;
          }
          float: left;position: relative;
          font-size:20px;
          font-family: 'Alibaba-PuHuiTi-R';
          color:rgba(255, 255, 255,0.4);
          padding:10px 20px;
          em{
            width: 1px;
            height: 18px;
            background:rgba(255, 255, 255,0.3);
            display: inline-block;
            position: absolute;
            right: 0px;
            top: 16px;
          }
        }
      }
    }
  }


  ::v-deep .ant-tabs-bar{
      border:none;
      margin: 16px 0 0px 0;
  }
 ::v-deep  .ant-tabs-nav.ant-tabs-nav-animated{
padding-left:26px;
}
  ::v-deep .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{
      border:none;
      background: transparent;
      font-size: 20px;
      font-family: AlibabaPuHuiTiM;
      color: rgba(255, 255, 255, 0.5);
  }
  ::v-deep .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
    color: rgba(255, 255, 255, 1);
  }




  ::v-deep .ant-affix .nav .nav-bar a,::v-deep .ant-affix .nav .nav-bar li{
    color:#333;
  }
    ::v-deep .nav .nav-login-btn a{
      color:#fff;
    }
     ::v-deep .nav .nav-login-btn:hover{
      background:#fff;
     }
  ::v-deep .nav .nav-login-btn a:hover, ::v-deep .nav .nav-login-btn:hover a{
    color: #2B68FF;

  }
  ::v-deep .nav .nav-login-btn,::v-deep .nav .nav-bar a,::v-deep .nav .nav-bar li{
      color: #ffffff
  }
  ::v-deep .ant-affix .nav .nav-login-btn{

      border-color:#198BFF;
      color: #2B68FF;
  }
  ::v-deep .nav .nav-login-btn{
    border-color:#fff;
  }
  ::v-deep .nav .nav-register-btn:hover a{
    color:#fff;background:none;
  }
  ::v-deep .nav .nav-register-btn:hover{
        background: linear-gradient(0deg, #217AF9 0%, #217AF9 100%);
  }
   ::v-deep .ant-affix .nav .nav-login-btn a{
    color: #2B68FF;
  }
}
</style>
